/**
 * utils.js - Utility-Funktionen für das Projekt
 */

// Projekt-Funktionen
export const getProjectName = (projectId) => {
  const projects = JSON.parse(localStorage.getItem("projects")) || [];
  const project = projects.find((p) => p.id === projectId);
  return project ? project.name : "Kein Projekt ausgewählt";
};

export const deleteProject = (projectId) => {
  const projects = JSON.parse(localStorage.getItem("projects")) || [];
  const updatedProjects = projects.filter(p => p.id !== projectId);
  localStorage.setItem("projects", JSON.stringify(updatedProjects));
  
  // Alle projektbezogenen Daten löschen
  localStorage.removeItem(`probedaten_${projectId}`);
  localStorage.removeItem(`teamAvailability_${projectId}`);
  localStorage.removeItem(`artisticTeam_${projectId}`);
  localStorage.removeItem(`absences_${projectId}`);
};

// Datums-Formatierungsfunktionen
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  if (dateStr.includes('.')) return dateStr;
  
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch (error) {
    console.error('Fehler bei der Datumsformatierung:', error);
    return dateStr;
  }
};

export const parseDate = (dateStr) => {
  if (!dateStr) return '';
  if (dateStr.includes('-')) return dateStr;
  
  try {
    const [day, month, year] = dateStr.split('.');
    if (!day || !month || !year) return dateStr;
    
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  } catch (error) {
    console.error('Fehler beim Parsen des Datums:', error);
    return dateStr;
  }
};

// Zeit-Formatierungsfunktionen
export const formatTime = (timeStr) => {
  if (!timeStr) return '';
  return timeStr.substring(0, 5);
};

// Datei-Operationen
export const readFileAsync = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsText(file);
  });
};

// Validierungsfunktionen
export const isValidDate = (dateStr) => {
  if (!dateStr) return false;
  const date = new Date(parseDate(dateStr));
  return date instanceof Date && !isNaN(date);
};

export const isValidTime = (timeStr) => {
  if (!timeStr) return false;
  const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
  return timeRegex.test(timeStr);
};

// LocalStorage Funktionen
export const saveToLocalStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Fehler beim Speichern in LocalStorage:', error);
    return false;
  }
};

export const loadFromLocalStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error('Fehler beim Laden aus LocalStorage:', error);
    return defaultValue;
  }
};

// Sortierungsfunktionen
export const sortByDate = (array, dateField, ascending = true) => {
  return [...array].sort((a, b) => {
    const dateA = new Date(parseDate(a[dateField]));
    const dateB = new Date(parseDate(b[dateField]));
    return ascending ? dateA - dateB : dateB - dateA;
  });
};

export const sortByString = (array, field, ascending = true) => {
  return [...array].sort((a, b) => {
    const valueA = (a[field] || '').toLowerCase();
    const valueB = (b[field] || '').toLowerCase();
    return ascending ? 
      valueA.localeCompare(valueB) : 
      valueB.localeCompare(valueA);
  });
};
